module.exports = __webpack_public_path__ + "static/media/tablet-alt.664e0f31.svg";